import { Divider, Drawer } from '@mantine/core';
import { useMounted } from '@mantine/hooks';
import { useUnit } from 'effector-react';
import { ReactNode } from 'react';
import { agent, fullscreen } from 'shared/lib';
import { sidebarModel } from '../../model';
import { SidebarFullscreenButton } from '../sidebar-fullscreen-button';
import { SidebarHomeButton } from '../sidebar-home-button';
import { SidebarMusicSlider } from '../sidebar-music-slider';
import { SidebarSettings } from '../sidebar-settings';
import { SidebarSoundsSlider } from '../sidebar-sounds-slider';
import cls from './sidebar.module.scss';

type SidebarProps = {
	targetId: string;
	topSlot: ReactNode;
	bottomSlot: ReactNode;
};

export const Sidebar = ({ targetId, topSlot, bottomSlot }: SidebarProps) => {
	const mounted = useMounted();
	const switcher = useUnit(sidebarModel.switcher);
	const desktop = useUnit(agent.$desktop);
	const { available } = useUnit(fullscreen);

	return (
		mounted && (
			<Drawer
				opened={switcher.active}
				classNames={{
					overlay: cls.sidebarOverlay,
					inner: cls.sidebarInner,
					content: cls.sidebarContent,
					body: cls.sidebarBody,
				}}
				portalProps={{
					target: document.getElementById(targetId)!,
				}}
				onClose={switcher.disable}
			>
				<div className={cls.sidebarActions}>
					<div className={cls.sidebarGroup}>{topSlot}</div>
					<Divider />
					<div className={cls.sidebarGroup}>
						<SidebarMusicSlider />
						<SidebarSoundsSlider />
					</div>
					<Divider />
					{desktop && available && (
						<>
							<div className={cls.sidebarGroup}>
								<SidebarFullscreenButton />
							</div>
							<Divider />
						</>
					)}
					<div className={cls.sidebarGroup}>{bottomSlot}</div>
					<Divider />
					<div className={cls.sidebarGroup}>
						<SidebarHomeButton />
					</div>
				</div>
				<SidebarSettings />
			</Drawer>
		)
	);
};
